import { Input, message } from 'antd'
import { useCallback, useState } from 'react'
import BaseEditingCellWithChars from './BaseEditingCellWithChars'
import BaseEditingAttributesCell from './BaseEditingAttributesCell'
import ShortcutManager from 'Services/ShortcutManager'


EditingDoubleCell = ({ defaultValue, r, c }) ->

  [value, setValue] = useState(defaultValue)

  el = useCallback((elem) ->
    elem?.focus()
    window.onkeydown = null
  , [])

  parseFieldValue = (val) ->
    fieldIsEmpty = !val? or val is ' '
    if fieldIsEmpty then '' else parseFloat(val)

  <BaseEditingCellWithChars defaultValue={defaultValue} setValue={setValue}>
    <BaseEditingAttributesCell value={value} initialValue={defaultValue} r={r} c={c}>
      <Input
        className="mousetrap"
        value={value}
        onChange={({ target: { value }}) ->
          if isNaN(value)
            message.warning('This column expects numbers only')
          else
            setValue(parseFieldValue(value))
        }
        style={{
          background: 'none',
          fontSize: '9pt',
          border: 'none',
          padding: 0,
          boxShadow: 'none',
          zIndex: 5
        }}
        ref={el}
      />
    </BaseEditingAttributesCell>
  </BaseEditingCellWithChars>

export default EditingDoubleCell
